import { Badge, Loader } from '@mantine/core';
import { useRouter } from 'next/router';
import { useProjectId } from '~/hooks/context/useProjectId';
import { api } from '~/trpc-extra/api';
import { closeAllModals } from '@mantine/modals';

export default function TestCard({ testId }: { testId: string }) {
  const router = useRouter();
  const projectId = useProjectId();

  if (!testId) {
    return null;
  }

  const { data: test, isLoading } = api.test.getTest.useQuery({ id: testId });

  return (
    <div
      className="relative flex w-full items-center justify-between rounded-xl bg-gray-100 px-4 py-2 shadow-md hover:cursor-pointer dark:bg-gray-600"
      onClick={async () => {
        closeAllModals();
        await router.push(`/project/${projectId}/test/${testId}`);
      }}
    >
      <Badge
        color="gray"
        radius="sm"
        size="sm"
        className="absolute right-3 top-0 -translate-y-1/2 translate-x-1/2"
      >
        TEST
      </Badge>
      {isLoading ?
        <Loader size="sm" />
      : <>
          <div className="mr-4 max-w-[150px] truncate dark:text-white">{test?.name || ''}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">{test?.createdAt.toLocaleDateString() || ''}</div>
        </>
      }
    </div>
  );
}
